import React, { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { webUrl } from '@/url';
import { Gallery } from '@/ui/gallery';
import styles from './spu-display.module.less';
import { ItemForClassification, SpuForVerification } from '@/interface/label';
import { Gender } from '@reversible/schema';

interface SpuDisplayProps {
  data: SpuForVerification | ItemForClassification;
}

export const SpuDisplay: FC<SpuDisplayProps> = memo(({
  data
}) => {
  const { name, brand, images, description, color, currency, price } = data;

  return (
    <div className={styles.spu_display}>
      <header className={styles.header}>
        <h2 className={styles.brand}>{brand}</h2>
        {"spuId" in data ? (
          <a target='_blank' href={webUrl.product({
            name,
            brand,
            gender: Gender.Women, // HACK: this gender is not always correct
            id: data.spuId,
          })} className={classNames(styles.name, styles.name_link)}>
            {name}
          </a>) :
          <h1 className={styles.name}>{name}</h1>
        }
        <h3 className={styles.color}>颜色：{color || ' '}</h3>
        <h3 className={styles.price}>
          价格：{Math.ceil(price) || ''} {currency || ''}
        </h3>
      </header>
      <Gallery data={images} />
      <p className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }} />
    </div>
  );
})
